<template>

  <v-dialog v-model="dialog" width="auto">
    <v-card max-width="400" text="Please connect with the organization to access the Doubt Forum" title="Error">
      <template v-slot:actions>
        <v-btn class="ms-auto" text="Ok" @click="dialog = false"></v-btn>
      </template>
    </v-card>
  </v-dialog>
  <v-dialog v-model="emailDialog" max-width="400">
    <template v-slot:activator="{ props: activatorProps }">
      <v-btn class="text-none font-weight-regular" prepend-icon="mdi-account" text="Edit Profile" variant="tonal"
        v-bind="activatorProps"></v-btn>
    </template>

    <v-card prepend-icon="mdi-account" title="Update Email">
      <v-card-text>
        <v-row dense>

          <v-col cols="12" md="10" sm="10">
            <v-text-field label="Email*" v-model="discourseEmail" required></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text="Close" variant="plain" @click="emailDialog = false"></v-btn>

        <v-btn color="primary" text="Save" variant="tonal" @click="updateEmail"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


  <v-navigation-drawer color="navColor" v-model="navDrawer" v-if="showNav" :permanent="mdAndUp" app>
    <v-list open-strategy="single" class="t-nav">
      <!--<v-list-item prepend-icon="mdi-home" title="Home" value="home"></v-list-item>-->
      <v-list-item @click="toggleDrawer()" :active="navItemActive('/learn')" prepend-icon="mdi-book-open-variant"
        title="Learn" value="learn" to="/learn" color="primary"></v-list-item>
      <v-list-item @click="toggleDrawerForTest()" :active="navItemActive('/testseries')" prepend-icon="mdi-file-outline"
        title="Test Series" value="testseries" to="/testseries" color="primary"></v-list-item>
      <v-list-item @click="toggleDrawer()" :active="navItemActive('/combinedreports')"
        prepend-icon="mdi-chart-box-outline" title="Combined Reports" value="combinedreports" to="/combinedreports"
        color="primary"></v-list-item>
      <v-list-item @click="toggleDrawer()" :active="navItemActive('/homework')" prepend-icon="mdi-bookshelf"
        title="Homework" value="homework" to="/homework" color="primary"></v-list-item>
      <v-list-item @click="toggleDrawer()" :active="navItemActive('/myclasses')" prepend-icon="mdi-laptop-account"
        title="Classes" value="myclasses" to="/myclasses" color="primary"></v-list-item>
      <v-list-item @click="toggleDrawer()" :active="navItemActive('/mynotifications')" prepend-icon="mdi-bell-outline"
        title="Notifications" value="mynotifications" to="/mynotifications" color="primary">
        <template #append>
          <v-badge v-if="unreadNotificationsCount > 0" :content="unreadNotificationsCount" color="red" overlap />
        </template>
      </v-list-item>
      <v-list-item @click="toggleDrawer()" :active="navItemActive('/calendar')" prepend-icon="mdi-calendar"
        title="Calendar" value="calendar" to="/calendar" color="primary"></v-list-item>
        
        <v-list-item @click="openDoubtForum()" v-if="discourseEnabled" :active="false" prepend-icon="mdi-message-question-outline"
        title="Doubts Hub" value="doubtforum" color="primary"></v-list-item>
        <v-list-item
          @click="toggleDrawer()"
          :active="navItemActive('/forms')"
          prepend-icon="mdi-clipboard-text"
          title="Feeback Forms"
          value="forms"
          to="/forms"
          color="primary">
        </v-list-item>
        <a href="https://support.vidyamandir.com" target="_blank" style="text-decoration: none;">
          <v-list-item :active="navItemActive('/support')" prepend-icon="mdi-face-agent"
            title="Need Support" value="calendar" color="primary"></v-list-item>
        </a>
    </v-list>
    <template v-slot:append>
      <div class="text-caption pa-2">
        v{{ appVersion }}.{{ appBuildNumber }}
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import { useDisplay } from "vuetify";
import { securePostAPI } from "@/services/apiService";
export default {
  name: "NavigationDrawer",
  setup() {
    const { mdAndUp } = useDisplay();

    return { mdAndUp };
  },
  props: {
    show: Boolean
  },
  created() {
    if (!this.mdAndUp) {
      this.$store.commit("toggleDrawer", false);
    }
  },
  data: () => ({
    dialog: false,
    emailDialog: false,
    discourseEmail: ""
  }),
  components: {},
  computed: {
    ...mapState(["unreadNotificationsCount"]),
    ...mapState([
      "appVersion",
      "appBuildNumber",
      "navDrawer",
      "navDrawerVisible",
      "testSeriesState"
    ]),
    showNav: {
      get() {
        return this.navDrawerVisible & this.show;
      }
    },
    currentRoute: {
      get() {
        return this.$route.path;
      }
    },
    discourseEnabled: {
      get() {
        return this.$store.state.featuresEnabled.discourseEnabled ?? false;
      }
    }
  },

  watch: {},

  methods: {
    updateEmail() {
      this.$store.dispatch("updateEmailForDiscourse", {
        rollNumber: this.$store.state.profileInfo.organization.rollNumber,
        email: this.discourseEmail
      })
      this.emailDialog = false
      console.log(this.$store.state.profileInfo.organization);

      this.openDiscourseUrl()
    },
    async openDoubtForum() {



      console.log(this.$store.state.profileInfo);

      if (this.$store.state.profileInfo.organization.status == true) {

        // let checkEmail = await securePostAPI({}, 'discoursetoken/checkEmail')
        // console.log(checkEmail);
        let email = this.$store.state.profileInfo.organization.email
        if (email != null && email != "null" && email.length > 0) {
          this.openDiscourseUrl()
        }
        else {
          this.dialog = true

        }

      }
      else {
        this.dialog = true
      }
    },
    async openDiscourseUrl() {
      let discourseToken = await securePostAPI({}, 'discoursetoken/gen')
      console.log(discourseToken);

      const url = `${this.$store.getters.apiBaseUrl}discoursetoken/cookies?token=${discourseToken.token}`;
      window.open(url, "_blank");
    },
    navItemActive(item) {
      if (this.currentRoute.startsWith(item)) {
        return true;
      }
      return false;
    },
    toggleDrawer() {
      if (!this.mdAndUp) {
        this.$store.commit("toggleDrawer", !this.navDrawer);
      }
    },
    toggleDrawerForTest() {
      if (!this.mdAndUp) {
        this.$store.commit("toggleDrawer", !this.navDrawer);
      }
      this.$store.commit("updateTestSeriesState", {
        submissionData: this.testSeriesState.submissionData,
        clear: true
      });
    }
  }
};
</script>

<style scoped>
.t-nav {
  font-family: "Inter", sans-serif !important;
  font-size: 0.8rem !important;
  font-style: normal !important;
  font-weight: 500 !important;
  color: black !important;
}
</style>
